import { render, staticRenderFns } from "./SwamtStart25.vue?vue&type=template&id=437525d4&scoped=true&"
import script from "./SwamtStart25.vue?vue&type=script&lang=js&"
export * from "./SwamtStart25.vue?vue&type=script&lang=js&"
import style0 from "./SwamtStart25.vue?vue&type=style&index=0&id=437525d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437525d4",
  null
  
)

export default component.exports